import { PresenceLayerState } from './presence-layer-state.ts';

/**
 * Process-wide singleton used both as the telepointer sink (when the drawable
 * presence layer is enabled) and as the source the selections presence effect
 * draws from.
 */
export const presenceLayerState = new PresenceLayerState();
